import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  constructor(
    private _http: HttpClient
  ) { }

  updateTokensById(organizationId: string) {
    return this._http.post(`${environment.url}/updateTokensByOrganization`, { organization: organizationId });
  }
}
